import { AceEditorTheme } from 'modules/aceEditor';
import { HtmlEditor } from 'modules/graphql';
import {
  CONTENT_EDITOR_LABEL_MAPPER,
  SIDE_BY_SIDE_EDITOR_THEME_MAPPER,
} from './ContentEditorPreferencesModal.constants';

export const getSideBySideEditorThemeOptions = () =>
  Object.keys(SIDE_BY_SIDE_EDITOR_THEME_MAPPER).map((theme) => ({
    id: theme,
    label: SIDE_BY_SIDE_EDITOR_THEME_MAPPER[theme as AceEditorTheme],
    value: theme,
  }));

export const getContentEditorOptions = () =>
  Object.keys(CONTENT_EDITOR_LABEL_MAPPER)
    .filter((opt) => opt !== HtmlEditor.Bee)
    .map((editor) => ({
      id: editor,
      label: CONTENT_EDITOR_LABEL_MAPPER[editor as HtmlEditor],
      value: editor,
    }));
